import MobileWarning from './MobileWarning';

export default MobileWarning;
